import api from './api';

export const suggestionsService = {
  // Book suggestions
  createBookSuggestion: async (suggestion) => {
    try {
      const response = await api.post('/suggestions/books', suggestion);
      return response.data;
    } catch (error) {
      console.error('Error creating book suggestion:', error);
      throw error;
    }
  },

  getBookSuggestions: async (statusFilter = null) => {
    try {
      const url = statusFilter ? `/suggestions/books?status_filter=${statusFilter}` : '/suggestions/books';
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching book suggestions:', error);
      throw error;
    }
  },

  updateBookSuggestion: async (id, update) => {
    try {
      const response = await api.put(`/suggestions/books/${id}`, update);
      return response.data;
    } catch (error) {
      console.error('Error updating book suggestion:', error);
      throw error;
    }
  },

  deleteBookSuggestion: async (id) => {
    try {
      const response = await api.delete(`/suggestions/books/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting book suggestion:', error);
      throw error;
    }
  },

  // Quiz requests
  createQuizRequest: async (request) => {
    try {
      const response = await api.post('/suggestions/quizzes', request);
      return response.data;
    } catch (error) {
      console.error('Error creating quiz request:', error);
      throw error;
    }
  },

  getQuizRequests: async (statusFilter = null) => {
    try {
      const url = statusFilter ? `/suggestions/quizzes?status_filter=${statusFilter}` : '/suggestions/quizzes';
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching quiz requests:', error);
      throw error;
    }
  },

  updateQuizRequest: async (id, update) => {
    try {
      const response = await api.put(`/suggestions/quizzes/${id}`, update);
      return response.data;
    } catch (error) {
      console.error('Error updating quiz request:', error);
      throw error;
    }
  },

  deleteQuizRequest: async (id) => {
    try {
      const response = await api.delete(`/suggestions/quizzes/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting quiz request:', error);
      throw error;
    }
  }
};